import { ResponsiveTarget } from '@immosky/types';
import { createAction, props } from '@ngrx/store';

export enum LayoutActions {
  SetIsMapVisible = '[Layout] Set is map visible',
  SetIsMobileFilterOpen = '[Layout] Open Filter Overlay',
  SetCurrentResponsiveTarget = '[Layout] Set current ResponsiveTarget',
  SetIsLoadingSearchResults = '[Layout] Set is loading search results',
}

export const setIsMapVisible = createAction(
  LayoutActions.SetIsMapVisible,
  props<{ isMapVisible: boolean }>()
);

export const setIsMobileFilterOpen = createAction(
  LayoutActions.SetIsMobileFilterOpen,
  props<{ isOpen: boolean }>()
);

export const setCurrentResponsiveTarget = createAction(
  LayoutActions.SetCurrentResponsiveTarget,
  props<{ target: ResponsiveTarget }>()
);

export const setIsLoadingSearchResults = createAction(
  LayoutActions.SetIsLoadingSearchResults,
  props<{ isLoading: boolean }>()
);
